import React, { useCallback, useContext, useState } from 'react';
import { StepBar, UserStatusBar } from '../../components';
import * as boardStages from '../../config/boardStages';
import { GlobalContext } from '../../context/GlobalState';
import CardsBoard from '../CardsBoard/CardsBoard';
import DiscussBoard from '../DiscussBoard';
import { NoPermissionErrorPage } from '../ErrorPage';
import MoodBoard from '../MoodBoard';
import SummaryBoard from '../SummaryBoard';
import S from './style';
import useListenCardsChange from './useListenCardsChange';
import useListenMoodsChange from './useListenMoodsChange';
import useListenRetrospectiveChange from './useListenRetrospectiveChange';

function Board() {
  const { retrospective, onLoading } = useContext(GlobalContext);
  const [error, setError] = useState(false);

  const handleErrorPage = useCallback(() => {
    onLoading(false);
    setError(true);
  }, [onLoading]);

  useListenMoodsChange();
  useListenCardsChange();
  useListenRetrospectiveChange(handleErrorPage);

  if (!retrospective && !error) return;
  if (error) return <NoPermissionErrorPage />;

  const steps =
    retrospective.teamMoodQuestions?.length > 0
      ? boardStages.stepWithMood
      : boardStages.normalStep;

  const stages = steps.map((item) => item.id);
  const stageIndex = stages.indexOf(retrospective.stage);

  const withScroll = () => {
    const isLastSteps = stageIndex >= stages.length - 2;
    const isMoodBoard = stages.length > 5 && stageIndex === 0;
    return isLastSteps || isMoodBoard;
  };

  const withUserStatusBar = () =>
    stageIndex <= stages.length - 2 && retrospective.usersDoneWithCurrentStage;

  return (
    <S.Container>
      <StepBar />
      <S.Board scroll={withScroll()} light={stageIndex === stages.length - 1}>
        <S.BoardWrapper>
          {stages.length === 6 && stageIndex === 0 && <MoodBoard />}
          {((stageIndex <= 3 && stageIndex >= 1 && stages.length === 6) ||
            (stageIndex <= 2 && stages.length === 5)) && <CardsBoard />}
          {stageIndex === stages.length - 2 && <DiscussBoard />}
          {stageIndex === stages.length - 1 && <SummaryBoard />}
        </S.BoardWrapper>
      </S.Board>
      {withUserStatusBar() && <UserStatusBar retrospective={retrospective} />}
    </S.Container>
  );
}

export default Board;
